// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import QRCode from '../../_common/api/QRCode';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Button from '../../_common/form/Button';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Modal from '../../_common/Modal';
import Card from '../Card';
import CountDown from '../../_common/CountDown';
import styled from 'styled-components';
import Loading from '../../_common/Loading';
import { HamQuest } from '../../../App';
import { currency } from '../../_common/api/utility';
import RequireFeature, { Features } from '../../_common/RequireFeature';

const PaddedDiv = styled.div`
    padding: 0.5em 0;
`;

const UseAppCredit = () => {
    const { state: {
        active_user
    } } = useGlobalState();

    const [token, setToken] = useState(false);
    const [expireTime, setExpireTime] = useState(30);

    const generateToken = () => {
        setToken(false);
        HamQuest.post(QuestRoute.tempToken, {
            TempIdType: 'GiftBalanceTempToken'
        })
            .then((res) => {
                if (!res.tempId) throw res.error;
                if (res.expirationTime > 0) setExpireTime(res.expirationTime);
                setToken(res.tempId);
            })
            .catch(ex => {
                console.log(ex);
                Modal.Show({
                    type: 'error',
                    title: 'Unable to Generate Token',
                    body: ex.blob || 'Sorry, something went wrong. Please try again.'
                });
            });
    }

    useEffect(() => {
        generateToken();
    }, []);

    return (
        <RequireFeature requiredFeatures={Features.AppCredit}>
            <Card title='App Credit' icon='creditCard'>
                {token ?
                    <>
                        <QRCode data={token} live expireTime={expireTime} />
                        <CountDown type='bar' time={expireTime} callback={() => setToken(null)} />
                        <PaddedDiv>
                            Your App Credit balance ({currency.format(active_user.account?.giftBalance ?? 0)}) will be used for this transaction. Scan this code at the kiosk to redeem.
                        </PaddedDiv>
                    </> : token === false ?
                        <Loading /> :
                        <>
                            <PaddedDiv>Token expired. Please generate a new token to use App Credit.</PaddedDiv>
                            <Button onClick={() => generateToken()}>Generate a new Token</Button>
                        </>
                }
            </Card>
        </RequireFeature>
    );
}

export default UseAppCredit;
